import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { CreditDispensation, CreditDispensationWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateCreditDispensation(): UseMutationResult<
  AxiosResponse<CreditDispensation>,
  AxiosError<ErrorMessage>,
  CreditDispensationWrite
> {
  const queryClient = useQueryClient();

  const updateCreditDispensation = (
    creditDispensation: CreditDispensationWrite,
  ): Promise<AxiosResponse<CreditDispensation>> => {
    return client.put(
      `credit-dispensations/${creditDispensation?.creditDispensationId}/`,
      creditDispensation,
    );
  };

  return useMutation(updateCreditDispensation, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['creditDispensations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
    },
  });
}
